import { useCallback, useEffect, useMemo, useState } from 'react'
import qs from 'qs'

import server from 'server/serverController2'
import { ProductDetailInfoActions } from 'store/actionCreators'

const useProductDetail = (productNo) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isEnd, setIsEnd] = useState(false)

  const loadProductDetailInfo = useMemo(async () => {
    try {
      const queryString = qs.stringify({
        show_challenge_task: true,
      })
      const response = await server.getRequestData(`commerce/products/${productNo}?${queryString}`)
      if (response.success !== 1) {
        const errData = response.error.res_data
        throw errData.detail_code
      }

      const { product } = response.data

      const discountPercent = calcDiscountPercent(
        product.lowest_challenge_price,
        product.lowest_price,
      )
      product['discount_percent'] = discountPercent

      return product
    } catch (error) {
      console.log(error)
    }
  }, [productNo])

  const calcDiscountPercent = (lowestChallengePrice, lowestPrice) => {
    const refundPrice = lowestPrice - lowestChallengePrice
    const discountPercent = Math.round((refundPrice / lowestPrice) * 100)
    return discountPercent
  }

  const setProductDetailInfo = useCallback(async () => {
    const productDetailData = await loadProductDetailInfo
    const { shipping, product_policy, vendor_info, review_url_info } = productDetailData

    ProductDetailInfoActions.updateProductDetailState({
      productInfo: productDetailData,
      shippingInfo: shipping,
      productPolicyInfo: product_policy,
      vendorInfo: vendor_info,
      reviewUrlInfo: review_url_info,
    })
    setIsLoading(false)
    setIsEnd(true)
  }, [loadProductDetailInfo])

  useEffect(() => {
    if (productNo && !isLoading && !isEnd) {
      setIsLoading(true)
      setProductDetailInfo()
    }
  }, [isEnd, isLoading, productNo, setProductDetailInfo])

  useEffect(() => {
    return () => ProductDetailInfoActions.initProductDetailState()
  }, [])

  return { isEnd, isLoading }
}

export default useProductDetail
